import { SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

import FormAddAllowedHost, { AddAllowedHostFormData } from 'dashboard/forms/FormAddAllowedHost';
import TableLayout, {
  TableActionTD,
  TableNullState,
  TableRemoveRow,
  TableTD,
  TableTH,
  TableTR,
} from 'dashboard/layouts/TableLayout';

const TableContainer = styled('div')`
  margin-bottom: ${SPACINGS.base * 2}px;
`;

interface AllowedHostsListProps {
  allowedHosts: string[];
  addAllowedHost: (values: AddAllowedHostFormData) => void;
  removeAllowedHost: (hostIndex: number) => void;
  disabled?: boolean;
}

const AllowedHostsList = ({
  allowedHosts,
  addAllowedHost,
  removeAllowedHost,
  disabled,
}: AllowedHostsListProps) => {
  const domainRows = allowedHosts.map((domain, i) => {
    return (
      <TableTR key={i}>
        <TableTD>{domain}</TableTD>
        <TableActionTD>
          {!disabled && (
            <TableRemoveRow
              id={`allowed-hosts-list-${domain}__remove-button`}
              data-test={`allowed-hosts-list-${domain}__remove-button`}
              onClick={() => removeAllowedHost(i)}
            />
          )}
        </TableActionTD>
      </TableTR>
    );
  });

  return (
    <div>
      <TableContainer>
        <TableLayout
          dataTest='allowed-hosts-list__table'
          isLoading={false}
          isEmpty={allowedHosts.length === 0}
          showHeader={true}
          nullState={
            <TableNullState dataTestBlock='allowed-hosts-list__null-state'>
              No domains on the allowlist.
            </TableNullState>
          }
          headerTR={
            <>
              <TableTH>Domain</TableTH>
              <TableTH>{/* Remove domain column */}</TableTH>
            </>
          }
        >
          {domainRows}
        </TableLayout>
      </TableContainer>
      <FormAddAllowedHost onSubmit={addAllowedHost} disabled={disabled} />
    </div>
  );
};

export default AllowedHostsList;
